import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-QuickEdit",
  "use": "icon-QuickEdit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-QuickEdit\"><path d=\"M4 17.17V4h16v6h2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-2H5.17L4 17.17z\" fill=\"currentColor\" /><path d=\"M22.5 16h-2.2l1.7-4h-5v6h2v5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol